<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h5>
                        التحكم في الأجهزة
                        <button v-b-modal.add @click="edit=false; add={csr_config: {}, csr_send: {}}" class="btn btn-sm btn-primary" style="border-radius: 50%; height: 30px; width: 30px; padding: 0px">
                            <i class="fa fa-plus"></i>
                        </button>
                    </h5>
                </div>
                <div class="card-body">
                    <div class="col-12 table-responsive">
                        <table class="table table-hover table-striped">
                            <thead class="border">
                                <th>
                                    العنوان
                                </th>
                                <th>
                                    الحالة
                                </th>
                                <th>
                                    تاريخ الإضافة
                                </th>
                                <th>
                                    خيارات
                                </th>
                            </thead>
                            <tbody>
                                <tr class="border" v-for="device in devices" :key="device._id">
                                    <td>
                                        {{ device.title }}
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-primary btn-block" v-if="device.status == 1">
                                            <img :src="require('@/assets/images/loading.svg')" style="width: 20px">
                                            إنشاء CSR...
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary btn-block" v-if="device.status == 3">
                                            <img :src="require('@/assets/images/loading.svg')" style="width: 20px">
                                            إرسال النماذج...
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary btn-block" v-if="device.status == 5">
                                            <img :src="require('@/assets/images/loading.svg')" style="width: 20px">
                                            إنشاء CSID...
                                        </button>
                                        <button class="btn btn-sm btn-primary btn-block" @click="generateCSR(device._id)" v-if="device.status == 0">
                                             ربط مع ZATCA
                                        </button>
                                        <button class="btn btn-sm btn-info btn-block" @click="sendExamples(device._id)" v-if="device.status == 2">
                                             ارسال امثلة
                                        </button>
                                        <button class="btn btn-sm btn-info btn-block" @click="createCSIDS(device._id)" v-if="device.status == 4">
                                                إنشاء CSIDS
                                        </button>
                                        <button class="btn btn-sm btn-primary btn-block" v-if="device.status == 6">
                                            <i class="fa fa-check"></i>
                                             تم الربط
                                        </button>
                                    </td>
                                    <td>
                                        {{ device.date.split(" ")[0] }}
                                    </td>
                                    <td>
                                        <button class="btn btn-sm" style="background: #05339C; color: white" @click="jwt(device._id)">
                                            <i class="fa fa-link"></i>
                                            JWT
                                        </button>&nbsp;
                                        <button class="btn btn-sm btn-primary" v-b-modal.add @click="edit=true;add=device;">
                                            <i class="fa fa-edit"></i>
                                            تعديل
                                        </button>&nbsp;
                                        <button class="btn btn-sm btn-danger" @click="deleteDevice(device._id)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="add" :title="edit ? add.title : 'إضافة جهاز'" hide-footer>
        <div class="form-group">
          <h5 for="">العنوان</h5>
          <input placeholder="عنوان الجهاز / الفرع الخ..." v-model="add.title" type="text"
            class="form-control form-control-lg">
        </div>
        <div class="form-group">
          <h5 for="">OTP</h5>
          <input placeholder="الـOTP من نظام فاتورة..." v-model="add.csr_send.OTP" type="number"
            class="form-control form-control-lg">
        </div>
        <div class="card card-body text-right">
            <div class="form-group">
            <h5 for="">csr.common.name</h5>
            <input placeholder="" v-model="add.csr_config['csr.common.name']" type="text"
                class="form-control form-control-lg">
                <small>Example: TST-886431145-399999999900003</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.serial.number</h5>
            <input placeholder="" v-model="add.csr_config['csr.serial.number']" type="text"
                class="form-control form-control-lg">
                <small>Example: 1-TST|2-TST|3-ed22f1d8-e6a2-1118-9b58-d9a8f11e445f</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.organization.identifier</h5>
            <input placeholder="" v-model="add.csr_config['csr.organization.identifier']" type="text"
                class="form-control form-control-lg">
                <small>Example: 399999999900003</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.organization.unit.name</h5>
            <input placeholder="" v-model="add.csr_config['csr.organization.unit.name']" type="text"
                class="form-control form-control-lg">
                <small>Example: فرع الرياض</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.organization.name</h5>
            <input placeholder="" v-model="add.csr_config['csr.organization.name']" type="text"
                class="form-control form-control-lg">
                <small>Example: شركة توريد التكنولوجيا بأقصى سرعة المحدودة</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.country.name</h5>
            <input placeholder="" v-model="add.csr_config['csr.country.name']" type="text"
                class="form-control form-control-lg">
                <small>Example: SA</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.invoice.type</h5>
            <input placeholder="" v-model="add.csr_config['csr.invoice.type']" type="text"
                class="form-control form-control-lg">
                <small>Example: 1100</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.location.address</h5>
            <input placeholder="" v-model="add.csr_config['csr.location.address']" type="text"
                class="form-control form-control-lg">
                <small>Example: RRRD2929</small>
            </div>
            <div class="form-group">
            <h5 for="">csr.industry.business.category</h5>
            <input placeholder="" v-model="add.csr_config['csr.industry.business.category']" type="text"
                class="form-control form-control-lg">
                <small>Example: أنشطة توريدات</small>
            </div>
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-primary" @click="editNow()" v-if="edit">
                تعديل الجهاز
            </button>
            <button class="btn btn-primary" @click="addNow()" v-if="!edit">
                إضافة الجهاز
            </button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data(){
    return {
        edit: false,
        add: {csr_config: {}, csr_send: {}},
        user: JSON.parse(localStorage.getItem('user')),
        devices: [],
        invterval: null
    }
  },
  beforeDestroy(){
    var g = this;
    if(g.invterval){
        clearInterval(g.invterval)
    }
  },
  created(){
    this.gett()
    var g = this;
    setInterval(() => {
        var f = false;
        g.devices.forEach(function(a){
            if(a.status == 1 || a.status == 3 || a.status == 5){
                f = true;
            }
        })
        if(f){
            g.gett()
        }
    }, 3000);
  },
  methods: {
    jwt(id){
        prompt('JWT is', this.user.jwt+','+id)
    },
    createCSIDS(id){
        var g = this;
        $.post(api + '/user/devices/createCSIDS', {jwt: g.user.jwt, id: id}).then(function(r){
            if(r.status == 100){
                g.gett()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    },
    deleteDevice(id){
        var g = this;
        if(confirm("متأكد من حذف الجهاز نهائياً؟")){
            $.post(api + '/user/devices/delete', {jwt: g.user.jwt, id: id}).then(function(r){
                if(r.status == 100){
                    g.gett()
                }else{
                    alert(r.response, 200)
                }
            }).fail(function(){
                alert('تعذر الاتصال بالخادم')
            })
        }
    },
    generateCSR(id){
        var g = this;
        $.post(api + '/user/devices/generateCSR', {jwt: g.user.jwt, id: id}).then(function(r){
            if(r.status == 100){
                g.gett()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    },
    sendExamples(id){
        var g = this;
        $.post(api + '/user/devices/sendExamples', {jwt: g.user.jwt, id: id}).then(function(r){
            if(r.status == 100){
                g.gett()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    },
    addNow(){
        var g = this;
        g.add.jwt = g.user.jwt;
        $.post(api + '/user/devices/add', g.add).then(function(r){
            if(r.status == 100){
                location.reload()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    },
    editNow(){
        var g = this;
        g.add.jwt = g.user.jwt;
        $.post(api + '/user/devices/edit', g.add).then(function(r){
            if(r.status == 100){
                location.reload()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    },
    gett(){
        var g = this;
        $.post(api + '/user/devices/list', {jwt: g.user.jwt}).then(function(r){
            if(r.status != 100){
                alert('تعذر الاتصال بالخادم')
            }else{
                g.devices = r.response
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    }
  }

}
</script>

<style>
.text-right input{
    text-align: right;
}
</style> 